import * as Sentry from '@sentry/angular';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  provideAppInitializer,
  inject,
  ErrorHandler,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideLottieOptions } from 'ngx-lottie';
import { httpErrorInterceptor } from './interceptors/http-error.interceptor';
import { routes } from './app.routes';
import { I18nService } from './services/i18n.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([httpErrorInterceptor])),
    // `lottie-web` is loaded lazily so it stays out of the initial bundle.
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideAppInitializer(() => {
      const i18nService = inject(I18nService);
      const browserLang = navigator.language.split('-')[0];
      const lang = ['en'].includes(browserLang) ? browserLang : 'en';
      return i18nService.loadTranslations(lang);
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
};
